@if (loading()) {
  <div class="loading-app-container">
    <div class="loading-app">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
}

<router-outlet />
